import gql from 'graphql-tag';

export const SaveContractorHireHistoryMutation = gql`
    mutation ($contractorHireHistoryInput: ContractorHireHistoryInput!) {
        saveContractorHireHistory (contractorHireHistory: $contractorHireHistoryInput)
        {
            id
        }
    }
`;
